// extracted by mini-css-extract-plugin
export default {"badge__container":"styles_badge__container__07MES","badge__text--no-active":"styles_badge__text--no-active__lzYgj"};